/* A/B test SØ.1, the new search: the mobile search field, the search panel's shortcuts and recent searches,
   and "Vis alle ... resultater". Moved from theme-custom.js; loaded (after it) only with the theme setting
   "New search" (search_new) on. */
(function () {
  // mobile header search: focus the predictive input inside the tap itself, otherwise iOS won't open the
  // keyboard (theme.js focuses it in a setTimeout). The open classes are set here too, since the input
  // can't take focus while its container is display:none, and this may run before theme.js's listener.
  document.querySelectorAll('.header-search-mobile .js-search-header').forEach(function ($trigger) {
    $trigger.addEventListener('click', function () {
      const $predictive = document.querySelector('predictive-search[data-context="header"]');
      const $container = document.querySelector('.site-header__search-container');
      if (!$predictive || !$container) return;

      $container.classList.add('is-active');
      $predictive.classList.add('is-active');
      $predictive.querySelector('input[type="search"]').focus();
    });
  });

  // header search: shortcuts (recent/popular searches, popular categories) while the field is empty,
  // the clear button, and the result count on the "Vis alle ... resultater" button
  const $headerSearch = document.querySelector('predictive-search[data-context="header"]');
  if ($headerSearch && $headerSearch.querySelector('[data-search-shortcuts]')) {
    const recentKey = 'mm_recent_searches';
    const recentLimit = 5;
    const $form = $headerSearch.querySelector('form');
    const $input = $headerSearch.querySelector('input[type="search"]');
    const $clear = $headerSearch.querySelector('.search__clear');
    const $results = $headerSearch.querySelector('#predictive-search');
    const $recent = $headerSearch.querySelector('[data-recent-searches]');
    const $recentList = $headerSearch.querySelector('[data-recent-list]');
    const viewAllLabel = $headerSearch.getAttribute('data-view-all-label');
    const submitLabel = $headerSearch.getAttribute('data-submit-label');

    const getRecent = function () {
      try {
        return JSON.parse(localStorage.getItem(recentKey)) || [];
      } catch (e) {
        return [];
      }
    };

    const setRecent = function (terms) {
      try {
        localStorage.setItem(recentKey, JSON.stringify(terms));
      } catch (e) {}
    };

    const saveRecent = function (term) {
      term = (term || '').trim();
      if (!term) return;
      const terms = getRecent().filter(function (t) { return t.toLowerCase() !== term.toLowerCase(); });
      terms.unshift(term);
      setRecent(terms.slice(0, recentLimit));
    };

    const renderRecent = function () {
      const terms = getRecent();
      $recentList.innerHTML = '';
      terms.forEach(function (term) {
        const $li = document.createElement('li');
        const $a = document.createElement('a');
        $a.className = 'search__shortcut';
        $a.href = $form.getAttribute('action') + '?q=' + encodeURIComponent(term);
        $a.setAttribute('data-search-term', term);
        $a.innerHTML = '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24"><circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/></svg>';
        const $text = document.createElement('span');
        $text.textContent = term;
        $a.appendChild($text);
        $li.appendChild($a);
        $recentList.appendChild($li);
      });
      $recent.hidden = terms.length === 0;
    };

    // is-empty shows the shortcuts and hides the (stale) results, see theme-custom.css
    const updateState = function () {
      const empty = !$input.value.trim();
      $headerSearch.classList.toggle('is-empty', empty);
      $clear.hidden = !$input.value;
      if (empty) renderRecent();
    };

    $input.addEventListener('input', updateState);
    document.addEventListener('predictive-search:open', updateState);
    updateState();

    $clear.addEventListener('click', function () {
      $input.value = '';
      updateState();
      $input.focus();
    });

    $headerSearch.querySelector('[data-recent-clear]').addEventListener('click', function () {
      setRecent([]);
      renderRecent();
      $input.focus();
    });

    // a recent/popular search fills the field and shows its live results instead of leaving the page
    $headerSearch.querySelector('[data-search-shortcuts]').addEventListener('click', function (e) {
      const $term = e.target.closest('[data-search-term]');
      if (!$term) return;
      e.preventDefault();
      $input.value = $term.getAttribute('data-search-term');
      $input.dispatchEvent(new Event('input', { bubbles: true }));
      $input.focus();
    });

    $form.addEventListener('submit', function () {
      saveRecent($input.value);
    });

    $results.addEventListener('click', function (e) {
      if (e.target.closest('a')) saveRecent($input.value);
    });

    // the predictive search API has no total, so fetch it from the search page with the same query the button submits
    let countRequest = 0;
    const updateViewAll = function () {
      const $btn = $results.querySelector('.results__search-btn');
      if (!$btn || !viewAllLabel || $btn.hasAttribute('data-count-loaded')) return;
      $btn.setAttribute('data-count-loaded', '');

      const terms = $btn.getAttribute('data-terms');
      const $label = $btn.querySelector('[data-search-btn-label]');
      // count: null = not known yet, 0 = the search finds nothing ("Søg efter ..."), otherwise "Vis alle [count] resultater ..."
      const setLabel = function (count) {
        if (count === 0 && submitLabel) {
          $label.textContent = submitLabel.replace('[terms]', terms);
          return;
        }
        let label = viewAllLabel.replace('[terms]', terms);
        label = count === null ? label.replace(/\s*\[count\]/, '') : label.replace('[count]', count.toLocaleString(document.documentElement.lang || 'da'));
        $label.textContent = label;
      };
      // without suggestions the button already says "Søg efter ...", keep that until the count says otherwise
      if (!$btn.hasAttribute('data-no-suggestions')) setLabel(null);

      const request = ++countRequest;
      const params = new URLSearchParams(new FormData($form));
      params.set('section_id', 'search-count');
      fetch($form.getAttribute('action') + '?' + params.toString())
        .then(function (response) { return response.text(); })
        .then(function (html) {
          if (request !== countRequest) return;
          const $count = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-search-results-count]');
          const count = $count ? parseInt($count.textContent, 10) : NaN;
          if (!isNaN(count)) setLabel(count);
        })
        .catch(function () {});
    };

    new MutationObserver(updateViewAll).observe($results, { childList: true });

    // mobile: size the full-screen panel to the visible area, so the button at its bottom stays above the on-screen keyboard
    if (window.visualViewport) {
      const fitToViewport = function () {
        $headerSearch.style.setProperty('--search-viewport-height', window.visualViewport.height + 'px');
        $headerSearch.style.setProperty('--search-viewport-top', window.visualViewport.offsetTop + 'px');
      };
      window.visualViewport.addEventListener('resize', fitToViewport);
      window.visualViewport.addEventListener('scroll', fitToViewport);
      fitToViewport();
    }
  }

})();
